import { createStyles, Theme } from '@material-ui/core';

export default (theme: Theme) =>
  createStyles({
    container: {
      display: 'inline-block',
    },
  });
